<app-button-modal
    title="Synchroniseer BPOST Labels"
    (closeModal)="close()"
    allowExit="true"
    class="sync-labels-modal"
>
    <div *ngIf="latestUploadStatus">
        <h5>Huidige Import (ID: {{ latestUploadStatus.id }})</h5>
        <dl>
            <dt>Gestart op: {{ latestUploadStatus.dateCreated | date : "dd-MM-yy HH:mm:ss" }}</dt>
            <dt>Laatste Update: {{ latestUploadStatus.updatedAt | date : "dd-MM-yy HH:mm:ss" }}</dt>
        </dl>
        <table class="table table-sm">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Totaal</th>
                    <th scope="col">Succes</th>
                    <th scope="col">overgeslagen</th>
                    <th scope="col">Fouten</th>
                    <th scope="col">Resterend</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ latestUploadStatus.totalAmount }}</td>
                    <td>{{ latestUploadStatus.successAmount }}</td>
                    <td>{{ latestUploadStatus.skippedAmount }}</td>
                    <td>{{ latestUploadStatus.erroredAmount }}</td>
                    <td>
                        {{ getRemainingAmount(latestUploadStatus) }}
                    </td>
                    <td>
                        <span
                            class="badge"
                            [ngClass]="{
                                'bg-success': latestUploadStatus.status === UPLOAD_STATUSSES.DONE,
                                'bg-warning':
                                    latestUploadStatus.status === UPLOAD_STATUSSES.STALLED,
                                'bg-primary':
                                    latestUploadStatus.status === UPLOAD_STATUSSES.WORKING,
                                'bg-danger': latestUploadStatus.status === UPLOAD_STATUSSES.ERROR,
                                'bg-danger':
                                    latestUploadStatus.status === UPLOAD_STATUSSES.CANCELLED
                            }"
                        >
                            {{ latestUploadStatus.status }}
                        </span>
                    </td>
                    <td>
                        <div class="d-flex gap-2">
                            <button
                                type="button"
                                class="btn btn-primary btn-sm mr-2"
                                title="Status verversen"
                                (click)="refreshSelectedStatus()"
                                [disabled]="isLoadingDetails"
                            >
                                <i class="fas fa-sync-alt" [class.fa-spin]="isLoadingDetails"></i>
                                Ververs
                            </button>

                            <button
                                *ngIf="!latestUploadStatus.isCompleted"
                                type="button"
                                class="btn btn-danger btn-sm"
                                title="Stoppen"
                                (click)="handleStopSync()"
                                [disabled]="isLoadingDetails"
                            >
                                <i class="fas fa-stop"></i> Stop Sync
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="!latestUploadStatus || latestUploadStatus.isCompleted">
        <div *ngIf="!csvIsParsed; else showData">
            <p>
                Selecteer een BPOST CSV export bestand. Voor een voorbeeld, zie het
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://osp.bpost.be/ShmBackEnd/private#SHIPMENT_OVERVIEW"
                    >download csv</a
                >
                overzicht van BPOST.
            </p>
            <p class="small text-muted">
                Het CSV bestand kan door komma's of door puntkomma's gescheiden worden.
            </p>
            <p class="small text-muted">
                Let Op!: De eerste rij van het CSV bestand bevat kolomkoppen. Deze rij wordt
                mogelijk overgeslagen bij de import.
            </p>
        </div>
        <ng-template #showData>
            <h5>Bestand '{{ fileName }}' bevat {{ parsedRows.length }} rij(en) met barcode.</h5>
        </ng-template>

        <div *ngIf="validationErrors && validationErrors.length > 0" class="my-3">
            <h6 class="error__title text-danger">Validatiefouten van Server</h6>
            <div
                *ngFor="let error of validationErrors"
                class="error alert alert-danger p-1 mb-1 small"
            >
                <p class="error__detail mb-0">
                    <strong>Veld(en):</strong> {{ error.fields?.join(", ") || "Onbekend" }}
                </p>
                <p class="error__detail mb-0">
                    <strong>Fout:</strong> {{ error.reason || "Onbekende serverfout" }}
                </p>
            </div>
        </div>

        <div
            *ngIf="
                currentLocalStatus === csvUploadStatusEnum.CSV_UPLOAD_FAILED &&
                !(validationErrors && validationErrors.length > 0)
            "
            class="my-3"
        >
            <p class="text-danger small">
                Kon het geselecteerde bestand niet verwerken. Controleer het formaat/inhoud en
                probeer opnieuw.
            </p>
        </div>

        <form #packageForm="ngForm" (ngSubmit)="buildAndSyncData()">
            <div class="buttons mt-3">
                <label class="btn btn-primary mb-0 me-2">
                    <span *ngIf="!fileName">
                        <i class="fas fa-arrow-alt-from-bottom fa-lg me-1"></i> KIES EEN BESTAND
                    </span>
                    <span *ngIf="fileName">
                        <i class="fas fa-check me-1"></i> {{ fileName | truncate : 25 }}
                    </span>
                    <input
                        type="file"
                        accept=".csv, text/csv, application/vnd.ms-excel"
                        (change)="changeListener($event)"
                        hidden
                    />
                </label>
                <button
                    *ngIf="csvIsParsed"
                    [disabled]="
                        !csvIsParsed ||
                        !parsedRows ||
                        parsedRows.length === 0 ||
                        (latestUploadStatus && !latestUploadStatus.isCompleted) ||
                        currentLocalStatus === csvUploadStatusEnum.ADDING_LABELS
                    "
                    class="btn btn-primary"
                    type="submit"
                >
                    <i class="fas fa-sync-alt me-1"></i> Synchroniseer
                    {{ parsedRows.length > 0 ? "(" + parsedRows.length + ")" : "" }}
                </button>
            </div>
        </form>
    </div>
</app-button-modal>
